import styled from 'styled-components';

export const SwiperContainer = styled.div``;

export const TextContainer = styled.div.attrs({
  className:
    'absolute bottom-0 left-0 h-auto w-full flex flex-col justify-end lg:justify-center items-center text-white text-center py-5 lg:py-8 z-50 bg-gradient-to-t from-black to-transparent/5'
})``;
